import { API_ENDPOINTS } from '../../Api/utils/endpoints'
import { makeAPIRequest } from '../utils/request'
import type { Banner } from './banners.types'

/**
 * Fetch all active banners
 */
export async function fetchActiveBanners(): Promise<Banner[]> {
  try {
    const bannerRes = await makeAPIRequest(API_ENDPOINTS.BANNERS, {
      method: 'GET',
      apiVersion: '4',
    })
    if (bannerRes?.error) {
      bannerRes.error?.message && console.error(bannerRes.error?.message)
      return []
    }
    return bannerRes?.data ?? []
  } catch (error) {
    return []
  }
}
